import React from 'react'
import Grid from '@mui/material/Grid2';
import "./footer.css";
import { useNavigate } from 'react-router-dom';

function Footer({generalData}) {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();
    const handleReloadnavigate = () => {
        window.location.reload(); // This will reload the page
        navigate("/");
    };
  return (
    <Grid size={{xs:12}} container justifyContent="center">
        <Grid size={{xs:11}} container justifyContent="center" className="py-5">
            <Grid size={{sm:12,xs:12}} container flexDirection="column" alignContent="center" alignItems="center" className="footer_logocontains">
                <img onClick={handleReloadnavigate} src={generalData.site_logo} alt=''/>
                <h4>{generalData.site_country} {generalData.site_state}</h4>
                <span className='d-md-block d-none'>{generalData.site_address} {generalData.site_city}, {generalData.site_pincode} <br/>Tel: {generalData.site_phone}</span>
                <span className='d-md-none d-block'>{generalData.site_address} {generalData.site_city},<br/> {generalData.site_pincode}, Tel: {generalData.site_phone}</span>
            </Grid>
            <Grid size={{xs:12}} container className="footer_socials justify-content-md-end justify-content-center">
                <a href={`${generalData.instagram_link}`} target="_blank" rel="noopener noreferrer"><img src={require('../../assets/instagram.svg').default} alt=''/></a>
                <a href={`${generalData.linkedin_link}`} target="_blank" rel="noopener noreferrer"><img src={require('../../assets/linkedin-logo.svg').default} alt=''/></a>
            </Grid>
            <Grid size={{xs:12}} container alignItems="center" className="terms_spanfooter"> 
                <Grid size={{sm:6,xs:12}} container className="text-center text-md-start">
                    <span>Please visit our <a href='/termsofservice'>Terms of Service</a> for more details, and read our <a href='/privacypolicy'>Privacy Policy</a>.</span>
                </Grid>
                <Grid size={{sm:6,xs:12}} container className="justify-content-md-end justify-content-center">
                    <span>BenchTrack © {currentYear}. All Rights Reserved.</span>
                </Grid>
            </Grid>
        </Grid>
    </Grid>
  )
}

export default Footer
